<template>
  <div class="newEntry">
    <!-- @click="newEntry" -->
    <v-menu
      transition="scale-transition"
      :close-on-content-clock="true"
      absolute
    >
      <template v-slot:activator="{ on }">
        <v-layout
          row
          v-on="on"
          :class="{
            touch: true,
            'pa-1': true,
            'not-weekend': !singleDate.isWeekend,
            weekend: singleDate.isWeekend,
          }"
        >
          <v-flex shrink>
            <v-card-text class="pa-1">
              <div class="text-truncate">
                <span class="font-weight-bold">
                  {{ singleDate.label | dayFormat }}
                </span>
              </div>
              <div></div>
              <div class="caption">
                <b> {{ singleDate.label | dateFormat }} </b>
              </div>
            </v-card-text>
          </v-flex>

          <v-flex grow> </v-flex>
          <v-flex shrink>
            <v-card-text class="pr-0 pb-2 pt-2 pl-2">
              <span class="body-1 font-weight-bold">
                {{ singleDate.totalHours }} hrs
              </span>
            </v-card-text>
          </v-flex>
          <v-flex shrink>
            <v-card-text class="pa-2">
              <v-icon
                :color="`${singleDate.isWeekend ? '#303030' : '#FFFFFF'}`"
              >
                mdi-plus-box
              </v-icon>
            </v-card-text>
          </v-flex>
        </v-layout>
      </template>
      <v-list class="popup pa-0">
        <v-list-tile @click="newEntry">
          <v-list-tile-title class="body-2 font-weight-bold text-xs-center pa-0"
            >New Entry</v-list-tile-title
          >
        </v-list-tile>

        <v-divider />

        <v-list-tile @click="fillDay">
          <v-list-tile-title class="body-2 font-weight-bold text-xs-center"
            >Fill Day from Favourite</v-list-tile-title
          >
        </v-list-tile>

        <v-divider />

        <v-list-tile @click="fillWeek">
          <v-list-tile-title class="body-2 font-weight-bold text-xs-center"
            >Fill Week from Favourite</v-list-tile-title
          >
        </v-list-tile>

        <v-divider />

        <v-list-tile @click="fillWeekFromLast">
          <v-list-tile-title class="body-2 font-weight-bold text-xs-center"
            >Fill Week from Last</v-list-tile-title
          >
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <widget-entryForm
        :formData="formData"
        :isNewEntry="true"
        @close="dialog = false"
        @save="newEntryCreated"
        :submitEntryFor="submitEntryFor"
      />
    </v-dialog>
    <v-dialog v-model="dateConfirmation" persistent max-width="450px">
      <v-icon @click="close" color="white" medium>mdi-close-circle-outline</v-icon>
      <v-card>
        <v-card-text v-for="(line, i) in workedOnMsg.split('\n')" :key="i">{{line}}<br/></v-card-text>
      </v-card>
      <v-divider />
      <v-btn color="pipefishGreen" @click="submitDays(false)">Yes</v-btn>
      <v-btn color="pipefishOrange" @click="submitDays(true)">No</v-btn>
    </v-dialog>
    <v-snackbar
      v-model="notification"
      :top="true"
      :timeout="4000"
      color="success"
    >
      {{ notificationText }}
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  props: ["formData", "submitEntryFor", "singleDate"],
  data: () => ({
    dialog: false,
    dateConfirmation: false,
    notification: false,
    notificationText: "",
    workedOnMsg: "",
    workedOnDates: [],
    days: [],
    submitType: '',
  }),
  computed: {
    ...mapState("app", ["userProfile"]),
    isMonday() {
      return this.formData.WorkedOn;
    },
  },
  methods: {
    newEntry() {
      this.dialog = true;
    },
    newEntryCreated(text) {
      (this.dialog = false), (this.notificationText = text);
      this.notification = true;
      this.$emit("updateEntries");
    },
    /**
     * Fill current selected week with favourite timesheet entry
     */
    fillWeek() {
      var self = this;
      var days = self._getWorkingWeek();
      this.submitType = 'week'

      this._checkHasEntries(days);
    },
    close() {
      this.dateConfirmation = false;
    },

    submitDays(useDays) {
      var self = this;
      this.dateConfirmation = false;
      var submitDates;
      if (useDays) {
        submitDates = this.days;
      } else {
        var _tempdays = this.days;
        for (var w = 0; w < this.workedOnDates.length; w++) {
          var workedOn = new Date(this.workedOnDates[w])
          console.log('WorkedOn is: ' + workedOn.toDateString());
          for(var d = 0; d < _tempdays.length; d++) {
            console.log('Day time is: ' + _tempdays[d].toDateString());
            if(_tempdays[d].toDateString() == workedOn.toDateString()) {
              _tempdays.splice(d, 1);
            }
          }
        }
        submitDates = _tempdays;
      }
      if(self.submitType == 'week') {
        self.$timesheetApi
        .submitMultipleEntries(
          self.userProfile.id,
          self.submitEntryFor.id,
          submitDates
        )
        .then((response) => {
          self.newEntryCreated("Saved timesheets for the week successfully");
        });
      } else if (self.submitType == 'last') {
        var setDays = [];
        var getDays = [];
        for (var day = 0; day < self.days.length; day++) {
          setDays[day] = self.days[day];
          getDays[day] = new Date(
            moment.utc(self.days[day]).clone().subtract(7, "days")
          );
        }

        self.$timesheetApi
          .submitLastWeekEntries(
            self.userProfile.id,
            self.submitEntryFor.id,
            getDays,
            setDays
          )
          .then((response) => {
            self.newEntryCreated("Saved timesheets for the week successfully");
          });
      }
      
    },

    fillWeekFromLast() {
      var self = this;
      var days = self._getWorkingWeek();
      this.submitType = 'last'

      this._checkHasEntries(days);
      /*
      
        */
    },

    fillDay() {
      var self = this;
      console.log('CBB --> ' + self.submitEntryFor.id);
      this.$timesheetApi
        .getRecentEntry(self.submitEntryFor.id)
        .then((response) => {
          if(!response) {
            alert('Appears to be no favourited entry.');
          } else {
            var workedOn = this.formData.WorkedOn.toDate();
            var toSubmit = {
              ClientId: response.clientId,
              ProjectId: response.projectId,
              ActivityId: response.activityId,
              PracticeId: response.activity.practice.Id,
              UserAccountId: this.submitEntryFor.id,
              WorkedOn: workedOn,
              HoursWorked: response.HoursWorked,
              Onsite: response.Onsite,
              Notes: response.Notes,
              ModifiedBy: this.userProfile.id,
              ModifiedOn: new Date(),
              Status: "submitted",
              StatementId: response.activity.statement.Id,
              StatementName: response.activity.statement.Name,
            };
            return toSubmit;
          }
        })
        .then((toSubmit) => {
          self.$timesheetApi.submitEntry(toSubmit).then((res) => {
            self.newEntryCreated("Submitted timesheet entry successfully");
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    _checkHasEntries(days) {
      var self = this;
      this.$timesheetApi
        .getTimesheetEntries(
          days[0],
          days[days.length - 1],
          this.submitEntryFor.id
        )
        .then((response) => {
          var workedOnDates = [];
          for (var r = 0; r < response.length; r++) {
            var workedOn = new Date(response[r].WorkedOn);
            var foundDate = days.filter(
              (d) => d.toLocaleDateString() == workedOn.toLocaleDateString()
            );
            if (
              foundDate.length > 0 &&
              workedOnDates.indexOf(workedOn.toDateString()) == -1
            ) {
              workedOnDates.push(workedOn.toDateString());
            }
          }

          if (workedOnDates.length > 0) {
            workedOnDates = workedOnDates.sort((a, b) => {
              var aDate = new Date(a);
              var bDate = new Date(b);
              return aDate.getTime() - bDate.getTime();
            });
            var msg = "There are already entries for this week. \nDo you want to skip these dates:\n";
            for (var w = 0; w < workedOnDates.length; w++) {
              msg += workedOnDates[w] + "\n";
            }
            self.workedOnDates = workedOnDates;
            self.days = days;
            self.workedOnMsg = msg;
            self.dateConfirmation = true;
          } else {
            self.days = days;
            self.submitDays(true);
          }
        });
    },

    _getWorkingWeek() {
      var days = [];
      var self = this;

      var startingMonday = moment
        .utc(new Date(self.formData.WorkedOn))
        .startOf("isoWeek");
      var day = startingMonday;
      for (var i = 0; i < 5; i++) {
        days.push(new Date(day));
        day = day.clone().add(1, "d");
      }

      return days;
    },
  },
  filters: {
    dayFormat(value) {
      return value.split(",")[0];
    },
    dateFormat(value) {
      return value.split(",")[1];
    },
  },
};
</script>

<style>
.newEntry:hover {
  /* opacity: 0.3; */
  background-color: #f9f9f9;
  cursor: pointer;
}
.newEntry:active {
  opacity: 0.5;
}

.popup {
  border: 3px solid #3eb4e0;
  border-radius: 10px;
}

.touch {
  height: 50px;
  border-radius: 3px;
}

.touch:hover {
  cursor: pointer;
  opacity: 0.9;
}

.weekend {
  background-color: #c8c8c8;
  color: #303030;
}

.not-weekend {
  background-color: #303030;
  color: #ffffff;
}
</style>
